import React, {Component} from 'react';
import {Link} from 'react-router-dom';


import G1 from '../../images/gp/G1.jpg';
import G2 from '../../images/gp/G2.jpg';
import G4 from '../../images/gp/G4.jpg';

import G25 from '../../images/gp/G25.jpg';
import G26 from '../../images/gp/G26.jpg';


import WEB1 from '../../images/web/WEB1.jpg';
import WEB2 from '../../images/web/WEB2.jpg';
import WEB6 from '../../images/web/WEB6.jpg';
import WEB7 from '../../images/web/WEB7.png';
import WEB11 from '../../images/web/WEB11.jpg';
import WEB10 from '../../images/web/WEB10.png';
import WEB17 from '../../images/web/WEB17.jpg';
import WEB16 from '../../images/web/WEB16.jpg';
import WEB18 from '../../images/web/WEB18.jpg';
import WEB19 from '../../images/web/WEB19.jpg';
import WEB20 from '../../images/web/WEB20.jpg';
import WEB21 from '../../images/web/WEB21.jpg';
import WEB22 from '../../images/web/WEB22.jpg';
import WEB23 from '../../images/web/WEB23.jpg';


class Graphic extends Component {
    render() {
        return (
            <div className="home margin-top">


                <section id="works" className="works section no-padding">
                    <div className="container-fluid">
                        <div className="row no-gutter">
                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={G1} class="work-box">
                                <img src={G1} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>
                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={G2}
                                                                                              className="work-box"> <img
                                src={G2} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>









                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={G25}
                                                                                              className="work-box"> <img
                                src={G25} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>

                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={G26}
                                                                                              className="work-box"> <img
                                src={G26} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>




                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB1}
                                                                                              className="work-box"> <img
                                src={WEB1} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>
                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB2}
                                                                                              className="work-box"> <img
                                src={WEB2} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>
                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB6}
                                                                                              className="work-box"> <img
                                src={WEB6} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>
                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB7}
                                                                                              className="work-box"> <img
                                src={WEB7} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>

                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB10}
                                                                                              className="work-box"> <img
                                src={WEB10} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>


                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB11}
                                                                                              className="work-box"> <img
                                src={WEB11} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>



                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB19}
                                                                                              className="work-box"> <img
                                src={WEB19} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>


                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB23}
                                                                                              className="work-box"> <img
                                src={WEB23} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>


                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB21}
                                                                                              className="work-box"> <img
                                src={WEB21} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>




                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB16}
                                                                                              className="work-box"> <img
                                src={WEB16} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>

                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB17}
                                                                                              className="work-box"> <img
                                src={WEB17} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>



                            <div className="col-lg-3 col-md-6 col-sm-6 work img_height"><Link to={WEB18}
                                                                                              className="work-box"> <img
                                src={WEB18} alt=""/>
                                <div className="overlay">
                                    <div className="overlay-caption">
                                        <h5>Project Name</h5>
                                        <p><i className="fa fa-search-plus fa-2x"></i></p>
                                    </div>
                                </div>

                            </Link></div>








                        </div>
                    </div>
                </section>


            </div>
        );
    }
}

export default Graphic;



// WEBPACK FOOTER //
// ./src/page/graphic/Graphic.js